"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationTokenSource = exports.CancellationTokenRegistration = exports.CancellationToken = exports.CancellationError = void 0;
exports.isCancellationError = isCancellationError;
var errors_1 = require("./errors");
function isCancellationError(e) {
    return e instanceof errors_1.CommonError && e.code === errors_1.ErrorCodes.Cancelled;
}
var CancellationError = /** @class */ (function (_super) {
    __extends(CancellationError, _super);
    function CancellationError(message) {
        return _super.call(this, message || "Cancelled", null, errors_1.ErrorCodes.Cancelled) || this;
    }
    return CancellationError;
}(errors_1.CommonError));
exports.CancellationError = CancellationError;
var CancellationToken = /** @class */ (function () {
    function CancellationToken(onCancel) {
        var _this = this;
        this.onCancel = onCancel;
        this.cancelled = false;
        this.subscribers = [];
        onCancel(function () {
            _this.cancelled = true;
            _this.subscribers.forEach(function (s) { return s(); });
        });
    }
    CancellationToken.prototype.throwIfCancelled = function () {
        if (this.isCancelled()) {
            throw new CancellationError();
        }
    };
    CancellationToken.prototype.isCancelled = function () {
        return this.cancelled === true;
    };
    CancellationToken.prototype.register = function (func) {
        var _this = this;
        this.throwIfCancelled();
        this.subscribers.push(func);
        return new CancellationTokenRegistration(function () {
            _this.subscribers.splice(_this.subscribers.indexOf(func), 1);
        });
    };
    CancellationToken.empty = function () {
        return new CancellationToken(function (onCancel) { return null; });
    };
    return CancellationToken;
}());
exports.CancellationToken = CancellationToken;
var CancellationTokenRegistration = /** @class */ (function () {
    function CancellationTokenRegistration(onDispose) {
        this.onDispose = onDispose;
        this.disposed = false;
    }
    CancellationTokenRegistration.prototype.isDisposed = function () {
        return this.disposed;
    };
    CancellationTokenRegistration.prototype.dispose = function () {
        this.onDispose && this.onDispose();
        this.disposed = true;
    };
    return CancellationTokenRegistration;
}());
exports.CancellationTokenRegistration = CancellationTokenRegistration;
var CancellationTokenSource = /** @class */ (function () {
    function CancellationTokenSource() {
        var _this = this;
        this.cancellationToken = new CancellationToken(function (onCancel) { return (_this.onCancel = onCancel); });
    }
    CancellationTokenSource.prototype.token = function () {
        return this.cancellationToken;
    };
    CancellationTokenSource.prototype.cancel = function () {
        this.onCancel();
    };
    return CancellationTokenSource;
}());
exports.CancellationTokenSource = CancellationTokenSource;
